// src/utils/monthlyColumns.js (or wherever you keep it)
// export function buildMonthLastWeekIndexMap(rawWeeklyRanges = [], rawMonthsMeta = []) {
//     // normalize weeklyRanges -> array
//     let weeklyRanges;
//     if (Array.isArray(rawWeeklyRanges)) weeklyRanges = rawWeeklyRanges;
//     else if (rawWeeklyRanges && typeof rawWeeklyRanges === 'object') {
//         if (Array.isArray(rawWeeklyRanges.weeks)) weeklyRanges = rawWeeklyRanges.weeks;
//         else if (Array.isArray(rawWeeklyRanges.data)) weeklyRanges = rawWeeklyRanges.data;
//         else weeklyRanges = Object.values(rawWeeklyRanges).filter(Boolean);
//     } else weeklyRanges = [];

//     // normalize months meta -> array
//     let monthsMeta;
//     if (Array.isArray(rawMonthsMeta)) monthsMeta = rawMonthsMeta;
//     else if (rawMonthsMeta && typeof rawMonthsMeta === 'object') {
//         if (Array.isArray(rawMonthsMeta.months)) monthsMeta = rawMonthsMeta.months;
//         else if (Array.isArray(rawMonthsMeta.data)) monthsMeta = rawMonthsMeta.data;
//         else monthsMeta = Object.values(rawMonthsMeta).filter(Boolean);
//     } else monthsMeta = [];

//     if (!weeklyRanges.length) return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };

//     const parseMonthFromRange = (wr) => {
//         if (!wr) return null;
//         // your weeklyRanges example uses {start: '01-Jan', end:'07-Jan'} -> parse start
//         const dateStr = wr.start || wr.startDate || wr.start_date || wr.start_at || wr.startLabel || null;
//         if (dateStr) {
//             // try to parse month token like '01-Jan' or '01-Jan-2025'
//             const m = String(dateStr).match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/i);
//             if (m) {
//                 const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//                 const monthNumber = monNames.findIndex(n => n.toLowerCase() === m[0].toLowerCase()) + 1;
//                 // year fallback: use current year (should be fine for labelling / grouping)
//                 return { year: new Date().getFullYear(), month: monthNumber };
//             }
//         }
//         // fallback: try end date, or label-like fields
//         const label = (wr.label || wr.weekLabel || wr.title || '').toString();
//         const mm = label.match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\b/i);
//         if (mm) {
//             const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
//             const monthNumber = monNames.findIndex(n => n.toLowerCase() === mm[0].toLowerCase()) + 1;
//             return { year: new Date().getFullYear(), month: monthNumber };
//         }
//         return null;
//     };

//     const weekMonths = weeklyRanges.map(wr => parseMonthFromRange(wr));
//     const lastIndexForMonthKey = new Map();
//     for (let i = 0; i < weekMonths.length; i++) {
//         const m = weekMonths[i];
//         if (!m) continue;
//         const key = `${m.year}-${m.month}`;
//         lastIndexForMonthKey.set(key, i);
//     }

//     const monthIdxToLastWeek = [];
//     const lastWeekIndexToMonthIdxObj = {}; // <-- plain object to return

//     for (let monthIdx = 0; monthIdx < monthsMeta.length; monthIdx++) {
//         const mm = monthsMeta[monthIdx];
//         let year, month;
//         if (Array.isArray(mm) && mm.length >= 2) {
//             [year, month] = mm;
//         } else if (mm && typeof mm === 'object') {
//             year = mm.year ?? mm[0] ?? new Date().getFullYear();
//             month = mm.month ?? mm[1] ?? mm.month_number ?? mm[0];
//         } else continue;

//         const key = `${year}-${month}`;
//         const lastIdx = lastIndexForMonthKey.has(key) ? lastIndexForMonthKey.get(key) : null;
//         monthIdxToLastWeek.push(lastIdx);
//         if (lastIdx !== null && lastIdx !== undefined) {
//             lastWeekIndexToMonthIdxObj[String(lastIdx)] = monthIdx;
//         }
//     }

//     // fallback inference if monthsMeta is absent
//     if (monthIdxToLastWeek.length === 0) {
//         const seenKeys = [];
//         for (let i = 0; i < weekMonths.length; i++) {
//             const m = weekMonths[i];
//             if (!m) continue;
//             const key = `${m.year}-${m.month}`;
//             if (!seenKeys.includes(key)) seenKeys.push(key);
//         }
//         seenKeys.forEach((key, idx) => {
//             for (let i = weekMonths.length - 1; i >= 0; i--) {
//                 const m = weekMonths[i];
//                 if (!m) continue;
//                 if (`${m.year}-${m.month}` === key) {
//                     lastWeekIndexToMonthIdxObj[String(i)] = idx;
//                     monthIdxToLastWeek[idx] = i;
//                     break;
//                 }
//             }
//         });
//     }

//     return { lastWeekIndexToMonthIdx: lastWeekIndexToMonthIdxObj, monthIdxToLastWeek };
// }

// src/utils/monthlyColumns.js
export function buildMonthLastWeekIndexMap(rawWeeklyRanges = [], rawMonthsMeta = []) {
    console.log("rawWeeklyRanges", rawWeeklyRanges, rawMonthsMeta)
    // normalize weeklyRanges
    let weeklyRanges = [];
    if (Array.isArray(rawWeeklyRanges)) weeklyRanges = rawWeeklyRanges;
    else if (rawWeeklyRanges && typeof rawWeeklyRanges === "object") {
        if (Array.isArray(rawWeeklyRanges.weeks)) weeklyRanges = rawWeeklyRanges.weeks;
        else if (Array.isArray(rawWeeklyRanges.data)) weeklyRanges = rawWeeklyRanges.data;
        else weeklyRanges = Object.values(rawWeeklyRanges).filter(Boolean);
    }

    // normalize monthsMeta
    let monthsMeta = [];
    if (Array.isArray(rawMonthsMeta)) monthsMeta = rawMonthsMeta;
    else if (rawMonthsMeta && typeof rawMonthsMeta === "object") {
        if (Array.isArray(rawMonthsMeta.months)) monthsMeta = rawMonthsMeta.months;
        else if (Array.isArray(rawMonthsMeta.data)) monthsMeta = rawMonthsMeta.data;
        else monthsMeta = Object.values(rawMonthsMeta).filter(Boolean);
    }

    if (!weeklyRanges.length || !monthsMeta.length) {
        return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
    }

    // helper: parse year+month reliably
    const parseYearMonth = (wr) => {
        const dateStr = wr.start || wr.startDate || wr.start_date || wr.start_at || wr.startLabel;
        if (!dateStr) return null;
        // Support formats like '01-Jan-2025'
        const match = String(dateStr).match(/(\d{1,2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)(?:-(\d{4}))?/i);
        if (!match) return null;

        const [, , monName, yearStr] = match;
        const monNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monNames.findIndex(n => n.toLowerCase() === monName.toLowerCase()) + 1;
        const year = yearStr ? parseInt(yearStr, 10) : new Date().getFullYear();
        return { year, month };
    };

    // build map: (year-month -> last week index)
    const lastIndexForMonthKey = new Map();
    weeklyRanges.forEach((wr, idx) => {
        const ym = parseYearMonth(wr);
        if (ym) {
            lastIndexForMonthKey.set(ym.month, idx);
        }
    });

    const monthIdxToLastWeek = [];
    const lastWeekIndexToMonthIdx = {};

    monthsMeta.forEach((mm, monthIdx) => {
        let month;
        if (Array.isArray(mm)) {
            [, month] = mm;
        } else if (typeof mm === "object") {
            month = mm.month ?? mm.month_number;
        }

        const key = month;
        const lastIdx = lastIndexForMonthKey.has(key) ? lastIndexForMonthKey.get(key) : null;

        monthIdxToLastWeek[monthIdx] = lastIdx;
        if (lastIdx !== null && lastIdx !== undefined) {
            lastWeekIndexToMonthIdx[lastIdx] = monthIdx;
        }
    });

    return { lastWeekIndexToMonthIdx, monthIdxToLastWeek };
}

